<script>
/**
 * Dashboard Component
 */
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    fields: Array,
    right: {
      type: Boolean,
      default: true,
    },
    dropup: {
      type: Boolean,
      default: false,
    },
    dropright: {
      type: Boolean,
      default: false,
    },
    dropleft: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 1,
      isBusy: false,
      oldContext: null,
    };
  },
  methods: {
    toggleColumn(columnKey) {
      if (this.hiddenColumns.includes(columnKey)) {
        this.hiddenColumns = this.hiddenColumns.filter((x) => x !== columnKey);
      } else {
        this.hiddenColumns = [...this.hiddenColumns, columnKey];
      }
    },
  },
  computed: {
    gridConfigText() {
      return 'gridConfig-' + this.id;
    },
    gridConfig: {
      get() {
        return this.$store.getters['localstorage/getDynamicConfigs'](
          this.gridConfigText
        );
      },
      set(value) {
        this.$store.dispatch('localstorage/setDynamicConfig', {
          code: this.gridConfigText,
          config: value,
        });
      },
    },
    hiddenColumns: {
      get() {
        return this.gridConfig.hiddenColumns;
      },
      set(value) {
        this.gridConfig = {
          ...this.gridConfig,
          hiddenColumns: value,
        };
      },
    },
  },
};
</script>

<template>
  <b-dropdown
    class="field-button custom-inventory-shadow"
    toggle-class="m-0 flex-vertical-center"
    id="dropdown-2"
    :right="right"
    :dropleft="dropleft"
    :dropright="dropright"
    :dropup="dropup"
    variant="primary"
    :text="$t('general.columns')"
  >
    <template #button-content>
      <i style="font-size: 1.6em" class="bx bx-cog"></i>
    </template>
    <template v-for="field in fields">
      <b-dropdown-form v-if="field.label != ''" :key="field.key">
        <b-form-checkbox
          :checked="!hiddenColumns.includes(field.key)"
          @change="toggleColumn(field.key)"
          class="mr-3"
          size="md"
          switch
        >
          <span style="white-space: nowrap">
            {{ field.label }}
          </span>
        </b-form-checkbox>
      </b-dropdown-form>
    </template>
  </b-dropdown>
</template>

<style scoped>
.field-button {
  border-radius: 5px;
  height: 40px;
}
</style>